import { Component, Input, OnInit } from '@angular/core';
import { Share } from '@capacitor/share';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-share-per-carrots',
  templateUrl: './profile-share-per-carrots.component.html',
  styleUrls: ['./profile-share-per-carrots.component.scss'],
})
export class ProfileSharePerCarrotsComponent  implements OnInit {
  public userData: any;
  @Input() srcIconCoin: string = '';
  constructor(private modalController: ModalController,
    private translate: TranslateService,
    private navParams: NavParams,
  ) { }

  ngOnInit() {
    this.userData = this.navParams.get('userId');
  }

  // Fechar modal
  goBack() {
    this.modalController.dismiss();
  }

  profileSharePerCarrots() {
    Share.share({
      text: this.translate.instant('checkVegglyMsg') + 'https://app.veggly.net/?referralUserId=' + this.userData?._id.$oid,
      title: this.translate.instant('checkVegglyTitle')
    }).then((sucess) => {
      console.log('share succesfull: ' + JSON.stringify(sucess));
    }).catch((error) => {
      console.log('share unsuccesfull: ' + JSON.stringify(error));
    });
  }

}
